import React, { useState, useEffect } from "react";
import styles from "./FilterWorkBag.module.scss";
import { connect } from "react-redux";
import { getSkills, filterWorkBagUsers, getAllWorkBagUsers, openSuscriptionModal} from "../../../../store/actions";
import { ReactComponent as FilterIcon } from "../../../../assets/svg/filterControlsIcon.svg";

const FilterWorkBag = ({
    getSkills,
    rubros,
    filterWorkBagUsers,
    getAllWorkBagUsers,
    setIsFiltered,
    setZoom,
    setSelectedUser,
    setLoading,
    isUserPremium,
    openSuscriptionModal,
    loading,
    setCenter,
    selectedOptionJurisdictions,
    selectedOptionSkills,
    setSelectedOptionJurisdictions,
    setSelectedOptionSkills,
    setFilterParamsForChildren }) => {
    const [selectedFilter, setSelectedFilter] = useState(null);
    const [disabledReset, setDisabledReset] = useState(true);
    const [hasFiltersChanged, setHasFiltersChanged] = useState(false);

    useEffect(() => {
        getSkills();
    }, []);

    const handleFilterClick = (filterName) => {
        if (selectedFilter === filterName) {
            setSelectedFilter(null);
        } else {
            setSelectedFilter(filterName);
        }
    };

    const handleOptionSelectJurisdiction = (option) => {
        if (option.id === 0) {
            setSelectedOptionJurisdictions([]);
            setFilterParamsForChildren((prev) => ({ ...prev, jurisdicciones: 'Todas' }));
        } else {
            setSelectedOptionJurisdictions((prev) =>
                prev.includes(option.id) ? prev.filter((id) => id !== option.id) : [...prev, option.id]
            );
            setFilterParamsForChildren((prev) => ({ ...prev, jurisdicciones: option.name }));
        }
        setSelectedFilter(null);
        setHasFiltersChanged(true);
    };

    const handleOptionSelectSkill = (option) => {
        setSelectedOptionSkills((prev) =>
            prev.includes(option.id) ? prev.filter((id) => id !== option.id) : [...prev, option.id]
        );
        setSelectedFilter(null);
        setHasFiltersChanged(true);
    };

    useEffect(() => {
        if (selectedOptionJurisdictions.length > 0 || selectedOptionSkills.length > 0) {
            setDisabledReset(false);
        } else {
            setDisabledReset(true);
        }
    }, [selectedOptionJurisdictions, selectedOptionSkills]);


    const handleResteFilters = () => {
        getAllWorkBagUsers();
        setSelectedOptionJurisdictions([]);
        setSelectedOptionSkills([]);
        setSelectedFilter(null);
        setIsFiltered(false);
        setZoom(3);
        setCenter([-38.416097, -63.616672]);
        setSelectedUser(null);
        setHasFiltersChanged(false);
    };

    const handleRemoveJurisdiction = (id) => {
        setSelectedOptionJurisdictions((prev) => prev.filter((jurisdictionId) => jurisdictionId !== id));
    };

    const handleRemoveSkill = (id) => {
        setSelectedOptionSkills((prev) => prev.filter((skillId) => skillId !== id));
    };

    useEffect(() => {
        setLoading(true);

        if (!isUserPremium && hasFiltersChanged) {
            openSuscriptionModal();
        } else {
            const filterParams = {
                jurisdicciones: selectedOptionJurisdictions,
                skills: selectedOptionSkills,
            };

            filterWorkBagUsers(filterParams);

            if (selectedOptionJurisdictions.length >= 1 || selectedOptionSkills.length >= 1) {
                setIsFiltered(true);
            } else {
                setIsFiltered(false);
                setZoom(3);
                setCenter([-38.416097, -63.616672]);
                setSelectedUser(null);
            }
        }

        const timeoutId = setTimeout(() => {
            setLoading(false);
        }, 2000);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [selectedOptionJurisdictions, selectedOptionSkills, isUserPremium]);


    const jurisdictionArray = [
        { id: 0, name: "Todas" },
        { id: 1, name: "Buenos Aires" },
        { id: 2, name: "Catamarca" },
        { id: 3, name: "Chaco" },
        { id: 4, name: "Chubut" },
        { id: 5, name: "Ciudad Autónoma De Buenos Aires" },
        { id: 6, name: "Córdoba" },
        { id: 7, name: "Corrientes" },
        { id: 8, name: "Entre Ríos" },
        { id: 9, name: "Formosa" },
        { id: 10, name: "Jujuy" },
        { id: 11, name: "La Pampa" },
        { id: 12, name: "La Rioja" },
        { id: 13, name: "Mendoza" },
        { id: 14, name: "Misiones" },
        { id: 15, name: "Neuquén" },
        { id: 16, name: "Río Negro" },
        { id: 17, name: "Salta" },
        { id: 18, name: "San Juan" },
        { id: 19, name: "San Luis" },
        { id: 20, name: "Santa Cruz" },
        { id: 21, name: "Santa Fe" },
        { id: 22, name: "Santiago del Estero" },
        { id: 23, name: "Tierra del Fuego, Antártida e Isla del Atlántico Sur" },
        { id: 24, name: "Tucumán" },
    ];

    return (
        <section className={styles.container}>
            <div className={styles.container_filter}>
                <div className={styles.mainFilter}>
                    <div className={styles.mainFilter_jurisdiction} onClick={() => handleFilterClick('jurisdiction')}>
                        <div className={`${styles.mainFilter_jurisdiction_infoContainer} ${selectedFilter === 'jurisdiction' ? styles.selectedFilter : ''}`}>
                            <div className={styles.mainFilter_jurisdiction_itemContent}>
                                <p className={styles.mainFilter_jurisdiction_title}>
                                    Jurisdicción
                                </p>
                                <p className={styles.mainFilter_jurisdiction_info}>
                                    {selectedOptionJurisdictions.length > 0 ? selectedOptionJurisdictions.map(id => jurisdictionArray.find(j => j.id === id).name).join(', ') : 'Todas'}
                                </p>
                            </div>
                        </div>
                        {selectedFilter === 'jurisdiction' && (
                            <div className={styles.mainFilter_jurisdiction_options}>
                                {jurisdictionArray.map((jurisdiction) => (
                                    <div className={styles.mainFilter_jurisdiction_options_item} key={jurisdiction.id} onClick={() => handleOptionSelectJurisdiction({ id: jurisdiction.id, name: jurisdiction.name })}>
                                        {jurisdiction.name}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className={styles.mainFilter_rubro} onClick={() => handleFilterClick('rubro')}>
                        <div className={`${styles.mainFilter_rubro_infoContainer} ${selectedFilter === 'rubro' ? styles.selectedFilter : ''}`}>
                            <div className={styles.mainFilter_rubro_itemContent}>
                                <p className={styles.mainFilter_rubro_title}>
                                    Rubro
                                </p>
                                <p className={styles.mainFilter_rubro_info}>
                                    {selectedOptionSkills.length > 0 ? selectedOptionSkills.map(id => rubros.find(r => r.id === id).name).join(', ') : 'Todos'}
                                </p>
                            </div>
                        </div>
                        {selectedFilter === 'rubro' && (
                            <div className={styles.mainFilter_rubro_options}>
                                {rubros.map((rubro) => (
                                    <div className={styles.mainFilter_rubro_options_item} key={rubro.id} onClick={() => handleOptionSelectSkill({ id: rubro.id, name: rubro.name })}>
                                        {rubro.name}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.mainFilter_button}>
                    <FilterIcon width={20} height={20} />
                    {selectedOptionJurisdictions.length + selectedOptionSkills.length > 0 && (
                        <span className={styles.mainFilter_button_title}>
                            {selectedOptionJurisdictions.length + selectedOptionSkills.length}
                        </span>
                    )}
                </div>
            </div>
            <div className={styles.selectedFilters}>
                <div className={styles.selectedFilters_boxes}>
                    {selectedOptionJurisdictions.map((id) => (
                        <div key={id} className={styles.selectedFilters_item}>
                            <span>{jurisdictionArray.find((j) => j.id === id).name}</span>
                            <button className={styles.selectedFilters_item_x} onClick={() => handleRemoveJurisdiction(id)}>x</button>
                        </div>
                    ))}
                    {selectedOptionSkills.map((id) => (
                        <div key={id} className={styles.selectedFilters_item}>
                            <span>{rubros.find((r) => r.id === id).name}</span>
                            <button className={styles.selectedFilters_item_x} onClick={() => handleRemoveSkill(id)}>x</button>
                        </div>
                    ))}
                </div>
                <button className={styles.mainFilter_buttonReset} onClick={() => handleResteFilters()} disabled={disabledReset}>
                    <p className={styles.mainFilter_buttonReset_title}>Limpiar</p>
                </button>
            </div>

        </section>
    );
};

const mapStateToProps = (state) => {
    return {
        workBagUsers: state.register.workBagUsers,
        rubros: state.register.skills,
        isUserPremium: state.general.isUserPremium,
    };
};

export default connect(mapStateToProps, { getSkills, filterWorkBagUsers, getAllWorkBagUsers, openSuscriptionModal })(FilterWorkBag);

